import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import ContactTable from "./Contact.js";
import { getApi } from "common/services/api";
import { postApi } from "common/services/api";
import Spinner from "common/components/spinner/Spinner";
import { GiClick } from "react-icons/gi";
import { toast } from "react-toastify";

const ContactModel = (props) => {
  const { onClose, isOpen, fieldName, setFieldValue, data } = props;
  const [selectedValues, setSelectedValues] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { Header: "#", accessor: "_id", isSortable: false, width: 10 },
    { Header: "title", accessor: "title" },
    { Header: "first Name", accessor: "firstName" },
    { Header: "last Name", accessor: "lastName" },
    { Header: "phone Number", accessor: "phoneNumber" },
    { Header: "Email Address", accessor: "email" },
    { Header: "physical Address", accessor: "physicalAddress" },
    { Header: "mailing Address", accessor: "mailingAddress" },
    { Header: "Contact Method", accessor: "preferredContactMethod" },
  ];

  const user = JSON.parse(localStorage.getItem("user"));
  // const fetchContactData = async () => {
  //     setIsLoading(true)
  //     let result = await getApi(user.role === 'superAdmin' ? 'api/contact/' : `api/contact/?createBy=${user._id}`);
  //     if (result && result.status == 200) {
  //         setData(result?.data);
  //     }
  //     setIsLoading(false)
  // }

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setFieldValue(fieldName, selectedValues);
      onClose();
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal onClose={onClose} size="full" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Contact</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Flex justifyContent={"center"} alignItems={"center"} width="100%">
              <Spinner />
            </Flex>
          ) : (
            <ContactTable
              tableData={data}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              columnsData={columns}
              title="Contact"
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="brand"
            size="sm"
            me={2}
            onClick={handleSubmit}
            disabled={isLoading ? true : false}
            leftIcon={<GiClick />}
          >
            {" "}
            {isLoading ? <Spinner /> : "Select"}
          </Button>
          <Button
            variant="outline"
            size="sm"
            colorScheme="red"
            onClick={() => onClose()}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ContactModel;
